// src/components/Testimonials.jsx

import React, { useState, useEffect, useRef } from 'react';
import '../Styles/Testimonials.css'; // Import the CSS file

const testimonialsData = [
    {
        quote: "I have got QOD treatment done here, the result was so good. Recommend this place to everyone who wants to get any kind of service. The staff was very good at explaining the treatments, they also suggested the treatment after analysing my hair texture.🙂 …",
        author: "Yusupet Praveen"
    },
    {
        quote: "Whenever I come to Hyderabad, I go to Groomwell saloon for my hair cut. They offer very good service, very friendly and efficient.I am very happy with them, and confidently recommend to anybody.",
        author: "Satyavani Kantamneni"
    },
    {
        quote: "I happened to get a nice haircut, and my friend recommended me to this salon. I have thin hair in general, and haircut seemed a bit difficult..But, Arun made sure that my hair looked voluminous after the treatment. Thank you Groom Well team, and Arun for special care towards ur customers.The staff is polite and receiving, which made me feel good in the very first instance.I would definitely visit you again and again.",
        author: "Manu Rocks"
    },
    {
        quote: "I did my eyebrows and facial and the service was done by vijaya  and the output was very good which I did not expected😍 …",
        author: "Uppala Revathi"
    },
    {
        quote: "Service is very good, place  is nice and cozy, people are friendly and reception is comfortable",
        author: "Krishna Kantamneni"
    },
    {
        quote: "I had a fantastic experience at Groomwell exclusive for woman Salon thanks to stylist Arun! From the moment I walked in, Chandu was warm, professional, and truly attentive to what I wanted. He took the time to understand my preferences, offered great suggestions, and delivered a haircut that was both stylish and easy to manage.",
        author: "Raj Mouli"
    },
     {
        quote: "I went for a hair color treatment, and Arun did an excellent job. The staff were very welcoming and polite. I highly recommend this parlour.",
        author: "Anindita Bhowmik"
    },
     {
        quote: "Excellent service vijaya reddy recommended  . Ambience is very nice",
        author: "Subbu G"
    },
     {
        quote: "The services are good and the staff specially Shambhavi and Satish both cater well to the clients needs.",
    },
     {
        quote: "I'm thoroughly impressed with this salon! The stylists are skilled and attentive, the atmosphere is clean and welcoming, and the staff are friendly and professional. I left feeling refreshed and confident, and I'd highly recommend this spot to anyone looking for top-notch service. The prices are reasonable, and the overall experience was well worth it.",
        author: "Adepu. Swetha"
    }
];

const Testimonials = () => {
    const [currentSlide, setCurrentSlide] = useState(0); // Index of the first visible testimonial
    const [slidesToShow, setSlidesToShow] = useState(3); // Default for desktop
    const carouselRef = useRef(null);

    // --- 1. Responsive Slides to Show ---
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) { // Mobile/Tablet
                setSlidesToShow(1);
            } else { // Desktop
                setSlidesToShow(3);
            }
        };

        handleResize(); // Set initially
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // --- 2. Automatic Scrolling ---
    useEffect(() => {
        let intervalId;
        if (carouselRef.current) {
            const scrollContainer = carouselRef.current;
            
            // Function to get the actual width of one card based on current slidesToShow
            const getCardWidth = () => {
                // Ensure there's at least one child and get its offsetWidth
                const firstCard = scrollContainer.querySelector('.testimonial_card');
                if (firstCard) {
                    // This calculates the width of one card including its right margin/gap
                    // It divides the total visible width by the number of cards shown
                    return scrollContainer.offsetWidth / slidesToShow;
                }
                return 0;
            };

            intervalId = setInterval(() => {
                setCurrentSlide(prevSlide => {
                    const nextSlide = (prevSlide + 1) % testimonialsData.length; // Loop through all testimonials indices

                    // Calculate scroll position based on nextSlide and actual card width
                    const cardWidth = getCardWidth();
                    if (cardWidth) {
                        scrollContainer.scrollTo({
                            left: nextSlide * cardWidth,
                            behavior: 'smooth'
                        });
                    }
                    
                    // If we're at the end and about to loop, jump back without animation
                    if (nextSlide === 0 && prevSlide === testimonialsData.length - 1) {
                         // Reset scroll position instantly to beginning for seamless loop start
                         setTimeout(() => {
                            scrollContainer.scrollTo({ left: 0, behavior: 'auto' });
                         }, 800); // Give enough time for the smooth scroll to finish before resetting
                    }

                    return nextSlide;
                });
            }, 3000); // Scroll every 3 seconds

        }

        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, [testimonialsData.length, slidesToShow]); // Re-run if data length or slidesToShow changes

    // --- 3. Manual Dot Click Scrolling ---
    const handleDotClick = (index) => {
        setCurrentSlide(index);
        if (carouselRef.current) {
            const scrollContainer = carouselRef.current;
            const firstCard = scrollContainer.querySelector('.testimonial_card');
            const cardWidth = firstCard ? scrollContainer.offsetWidth / slidesToShow : 0; // Recalculate card width
            
            if (cardWidth) {
                scrollContainer.scrollTo({
                    left: index * cardWidth,
                    behavior: 'smooth'
                });
            }
        }
    };

    // Calculate total dots: one dot per individual testimonial
    const totalDots = testimonialsData.length;

    return (
        <section className="testimonials_section">
            <p className="testimonials_subheading">Testimonials</p>
            <h2 className="testimonials_main_heading">What are People Saying</h2>

            <div className="testimonials_carousel_container">
                <div 
                    className="testimonials_carousel_track" 
                    ref={carouselRef}
                    style={{ '--slides-to-show': slidesToShow }} // Pass slidesToShow as a CSS variable
                >
                    {testimonialsData.map((testimonial, index) => (
                        <div key={index} className="testimonial_card">
                            <span className="quote_icon">“</span>
                            <p className="testimonial_quote">{testimonial.quote}</p>
                            <p className="testimonial_author">- {testimonial.author}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="carousel_pagination_dots">
                {Array.from({ length: totalDots }).map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => handleDotClick(index)}
                    ></span>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;